import { AccountChargesForPeriodMappedData } from '../../../../mappers/accounts/statistic/charges/index';
import { createDataFetchSlice } from '../../../../utils/dataFetch';


export const adminAccountStatisticChargesSlice = createDataFetchSlice<
    AccountChargesForPeriodMappedData
>({ name: 'charges' });
